import { CmsBannerId } from "../../../cms/cms-banners/cm-banner-id/cms-banner-id";
import { OfferConfiguration } from "../../../configurations/config-data-sections/link-to-offer.configuration";
import { IServiceFactory } from "../../../service-factory.interface";
import { IOffer } from "../../player-offerings.service";


export abstract class OfferBase implements IOffer {

    constructor(protected services: IServiceFactory, protected offerConfig: OfferConfiguration) {
    }

    abstract render(): React.ReactNode;

    abstract shouldUseLinkToOfferAnimation(): boolean;

    isHighPriorityOffer(): boolean {
        return false;
    }
    
    shouldBeVisible(): boolean {
        return this.offerConfig.display;
    }

    get bannerId(): CmsBannerId {
        return new CmsBannerId(this.offerConfig.componentID, this.offerConfig.templateID, null);
    }

    abstract readonly id: string;
    abstract readonly analyticsCategory: string;
}
